import Input from './input';


function maxPojectionSize(focallength, dist) {
	const imagesize = 40; //mm
	return Math.round(imagesize * ((dist * 1000) - (1 * focallength)) / (focallength * 1000));
}

function minDistance(focallength, si) {
	const imagesize = 40; //mm
	return Math.round((si * (focallength * 1000) / imagesize + (1 * focallength)) / 1000);
}

function imageSize(focallength) {
	return Math.round((size * focallength * 1000) / ((distance * 1000) - (1 * focallength)));
}

function updateInput() {
	maxSizeValueEl.textContent = `max. ${(maxPojectionSize(45, distance) / 100).toLocaleString('de-DE')} m`;
	sizeRangeInput.el.setAttribute('max', maxPojectionSize(45, distance) / 100);

	minDistanceValueEl.textContent = `min. ${(minDistance(45, size) / 100).toLocaleString('de-DE')} m`;
	distanceRangeInput.el.setAttribute('min', minDistance(45, size) / 100);

	distanceRangeInput.setValue(distance / 100);
	distanceNumberInput.setValue(distance / 100);
	sizeNumberInput.setValue(Math.round(size) / 100);
	sizeRangeInput.setValue(Math.round(size) / 100);
}

function updateImage() {
	image.setAttribute('style', `left:${(100 * 0.89) - Math.round(distance / 25) * 0.78}%`);
}


function update() {
	updateInput();
	updateColumn(lenses);
	updateColumn(focals);
	updateColumn(masks);
	updateColumn(usages);
	updateColumn(lenseimages);
	updateMasks();
	updateImage();
}

function updateColumn(elements) {
	let bestItem;
	for (const item of elements) {
		let focalLength = parseInt(item.getAttribute('data-focallength'), 10);
		item.classList.remove('slx-projcal--best');
		if (size > maxPojectionSize(focalLength, distance)) {
			item.classList.add('slx-projcal--disabled');
		} else {
			bestItem = item;
			item.classList.remove('slx-projcal--disabled');
		}
	}
	if (bestItem !== undefined) {
		bestItem.classList.add('slx-projcal--best');
	}
}

function updateMasks() {
	for (const item of masks) {
		let focalLength = parseInt(item.getAttribute('data-focallength'), 10);
		if (imageSize(focalLength) > 40) {
			item.textContent = '> 40 mm';
		} else {
			item.textContent = `${imageSize(focalLength)} mm`;
		}
	}
}

function onDistanceChange(value) {
	if (!isNaN(parseFloat(value))) {
		if (size < maxPojectionSize(45, parseFloat(value) * 100)) {
			distance = parseFloat(value) * 100;
			size = Math.min(size, maxPojectionSize(45, distance));
		}
	}
	update();
}

function onSizeChange(value) {
	if (!isNaN(parseFloat(value))) {
		//accept input
		size = Math.min(parseFloat(value) * 100, maxPojectionSize(45, distance));
	}
	update();
}


const container = document.query('.slx-projcal');
let distance = 800;
let size = 200;
let lenses;
let focals;
let masks;
let usages;
let lenseimages;
let focalLengths = [];
let distanceRangeInput;
let distanceNumberInput;
let sizeRangeInput;
let sizeNumberInput;

let maxSizeValueEl;
let minDistanceValueEl;
let sizeRangeValueEl;
let distanceRangeValueEl;
let image;

if (container !== null) {
	lenses = container.querySelectorAll('.js-slx-projcal__lense');
	focals = container.querySelectorAll('.js-slx-projcal__focal');
	masks = container.querySelectorAll('.js-slx-projcal__mask');
	usages = container.querySelectorAll('.js-slx-projcal__usage');
	lenseimages = container.querySelectorAll('.js-slx-projcal__lenseimage');
	maxSizeValueEl = document.getElementById('slx-projcal__size-max');
	minDistanceValueEl = document.getElementById('slx-projcal__distance-min');
	sizeRangeValueEl = document.getElementById('slx-projcal__size-value');
	distanceRangeValueEl = document.getElementById('slx-projcal__distance-value');
	image = document.getElementById('js-slx-projcal__image');

	for (const lense of lenses) {
		let focalLength = parseInt(lense.getAttribute('data-focallength'), 10);
		focalLengths.push(focalLength);
	}

	const distanceRangeInputEl = document.query('.js-slx-projcal__distance-input');
	distanceRangeInput = new Input({el: distanceRangeInputEl});
	distanceRangeInput.start();
	distanceRangeInput.setValue(distance / 100);
	distanceRangeInput.events.on('change', onDistanceChange);
	distanceRangeInputEl.addEventListener('change', (e) => {
		if (e.target === distanceRangeInputEl) {
			onDistanceChange(e.target.value); // fix for ie 11
		}
	});

	const distanceNumberInputEl = document.query('.js-slx-projcal__distance-input-number');
	distanceNumberInput = new Input({el: distanceNumberInputEl});
	distanceNumberInput.start();
	distanceNumberInput.setValue(distance / 100);
	distanceNumberInput.events.on('blur', onDistanceChange);

	const sizeRangeInputEl = document.query('.js-slx-projcal__size-input');
	sizeRangeInput = new Input({el: sizeRangeInputEl});
	sizeRangeInput.start();
	sizeRangeInput.setValue(size / 100);
	sizeRangeInput.events.on('change', onSizeChange);
	sizeRangeInputEl.addEventListener('change', (e) => {
		if (e.target === sizeRangeInputEl) {
			onSizeChange(e.target.value); // fix for ie 11
		}
	});

	const sizeNumberInputEl = document.query('.js-slx-projcal__size-input-number');
	sizeNumberInput = new Input({el: sizeNumberInputEl});
	sizeNumberInput.start();
	sizeNumberInput.setValue(size / 100);
	sizeNumberInput.events.on('blur', onSizeChange);

	update();
}
